import snackbar from '../snackbar';

const Status = {
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
  DENIED: 'DENIED',
  SKIPPED: 'SKIPPED',
};

function respondWithDenied() {
  return {
    status: Status.DENIED,
  };
}

function respondWithFailure(error) {
  return {
    status: Status.FAILURE,
    error,
  };
}

function respondWithSuccess(payload = {}) {
  return {
    status: Status.SUCCESS,
    ...payload,
  };
}

function respondAndNotifyWithDenied(...args) {
  snackbar.show({
    text: 'Acesso negado!',
  });
  return respondWithDenied(...args);
}

function respondAndNotifyWithSuccess(...args) {
  snackbar.show({
    text: 'Concluído com sucesso!',
  });
  return respondWithSuccess(...args);
}

function respondAndNotifyWithFailure(...args) {
  snackbar.show({
    text: 'Ops, não foi possível concluir!',
  });
  return respondWithFailure(...args);
}

export default {
  Status,
  respondWithDenied,
  respondWithFailure,
  respondWithSuccess,
  respondAndNotifyWithDenied,
  respondAndNotifyWithFailure,
  respondAndNotifyWithSuccess,
};



// WEBPACK FOOTER //
// ./src/Api/Base.js